"use client";

import { useState } from "react";
import { LeadsCRM } from "@/components/LeadsCRM";
import { LeadsKanban } from "@/components/LeadsKanban";
import { LayoutGrid, Table, RefreshCw } from "lucide-react";

export default function LeadsPage() {
  const [view, setView] = useState<"board" | "table">("board");
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState<{ added: number; updated: number; errors: string[] } | null>(null);

  const syncSheets = async () => {
    setSyncing(true);
    setSyncResult(null);
    try {
      const res = await fetch("/api/leads/sync", { method: "POST" });
      const data = await res.json();
      setSyncResult(data);
      setTimeout(() => setSyncResult(null), 8000);
    } catch (err) {
      setSyncResult({ added: 0, updated: 0, errors: [String(err)] });
    } finally {
      setSyncing(false);
    }
  };

  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-5">
        <h2 className="text-2xl font-bold">Leads CRM</h2>
        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={syncSheets}
            disabled={syncing}
            className="px-3 py-2 rounded-lg border border-[var(--border)] text-sm flex items-center gap-2 hover:bg-[var(--bg-hover)] disabled:opacity-50"
          >
            <RefreshCw size={16} className={syncing ? "animate-spin" : ""} />
            {syncing ? "Syncing..." : "Sync Google Sheets"}
          </button>
          <div className="flex rounded-lg border border-[var(--border)] overflow-hidden">
            <button
              onClick={() => setView("board")}
              className={`px-3 py-2 text-sm flex items-center gap-1.5 transition-colors ${view === "board" ? "bg-[var(--accent)] text-white" : "hover:bg-[var(--bg-hover)]"}`}
            >
              <LayoutGrid size={15} />Board
            </button>
            <button
              onClick={() => setView("table")}
              className={`px-3 py-2 text-sm flex items-center gap-1.5 transition-colors ${view === "table" ? "bg-[var(--accent)] text-white" : "hover:bg-[var(--bg-hover)]"}`}
            >
              <Table size={15} />Table
            </button>
          </div>
        </div>
      </div>

      {syncResult && (
        <div className={`mb-4 p-3 rounded-lg border text-sm ${syncResult.errors.length ? "border-[var(--red)]/40 bg-[var(--red)]/10" : "border-[var(--green)]/40 bg-[var(--green)]/10"}`}>
          {syncResult.errors.length > 0 ? (
            <div>Sync errors: {syncResult.errors.join(", ")}</div>
          ) : (
            <div>✅ Sync complete — {syncResult.added} added, {syncResult.updated} updated</div>
          )}
        </div>
      )}

      {view === "board" ? <LeadsKanban /> : <LeadsCRM />}
    </div>
  );
}
